
import request from '@/utils/request' // 引入请求模块

// 首页
export function getWorkIndexList (params) {
  return request({
    url: '/workSystem/getWorkIndexList',
    method: 'get',
    params
  })
}

// 工作详情
export function getWorkDetail (params) {
  return request({
    url: '/workSystem/getWorkDetail',
    method: 'get',
    params
  })
}

//个人务工信息查询
export function getSelfWorkApplicantDetail (params) {
  return request({
    url: '/workSystem/getSelfWorkApplicantDetail',
    method: 'get',
    params
  })
}

// 获取分享二维码
export function getShareQrCodeWithUser (params) {
  return request({
    url: '/workSystem/getShareQrCodeWithUser',
    method: 'get',
    params
  })
}

// 务工档案新增修改
export function createOrUpdateWorkApplicant (data) {
  return request({
    url: '/workSystem/createOrUpdateWorkApplicant',
    method: 'post',
    data
  })
}

// 务工信息列表
export function getWorkApplicantsList (params) {
  return request({
    url: '/workSystem/getWorkApplicantsList',
    method: 'get',
    params
  })
}

//获取工种列表
export function getWorkTypeList (params) {
  return request({
    url: '/workSystem/getWorkTypeList',
    method: 'get',
    params
  })
}
//查询一条务工信息
export function getOneWorkApplicantDetail (params) {
  return request({
    url: '/workSystem/getOneWorkApplicantDetail',
    method: 'get',
    params
  })
}

//查询一条务工信息
export function getAdminConfig (params) {
  return request({
    url: '/common/system/getAdminConfig',
    method: 'get',
    params
  })
}
//查询一条务工信息
export function getDownloadShareImgUrl (data) {
  return request({
    url: '/workSystem/getDownloadShareImgUrl',
    method: 'post',
    data:data
  })
}

//务工报名
export function createUserHireInfo (data) {
  return request({
    url: '/workSystem/createUserHireInfo',
    method: 'post',
    data:data
  })
}

//企业微信分享参数
export function getWorkWechatShareParams (params) {
  return request({
    url: '/workSystem/getWorkWechatShareParams',
    method: 'get',
    params
  })
}

//获取邀请人户籍地址
export function getNodeManagerLevelAddress (params) {
  return request({
    url: '/workSystem/getNodeManagerLevelAddress',
    method: 'get',
    params
  })
}

//数据看板
export function getDataBoard (params) {
  return request({
    url: '/workSystem/getDataBoard',
    method: 'get',
    params
  })
}

//薪酬列表
export function getWorkIncomeRangeList (params) {
  return request({
    url: '/workSystem/getWorkIncomeRangeList',
    method: 'get',
    params
  })
}

